import type { ThemeMode } from '@/hooks/useLightMode'
import { useLightMode } from '@/hooks/useLightMode'

import { Global, css } from '@emotion/react'

import { colors } from './theme'

const buildStyles = (backgroundColor: string) => css`
  body {
    background-color: ${backgroundColor};
  }
  html {
    overflow: hidden;
  }
  .react-datepicker {
    font-family: 'Euclid Square';
    font-weight: 400;
    font-style: normal;
  }
`

/**
 * Body background. In practice this is a backstop, not a visible surface:
 * `AppLayout` paints nothing, but every page below it fills the viewport
 * itself (`PageLayout`, `DarkPageLayout`, `SettingsShell`, `ErrorLayout`), and
 * `html { overflow: hidden }` leaves no overscroll gap. Pre-hydration the
 * `<style>` in `_document.tsx` is what paints.
 *
 * It reads `bg.app` rather than a literal so the backstop can't contradict the
 * page painted over it — this file used to hardcode #f0f5fd, which had already
 * drifted from `bg.app.light`. Mode-aware because dark is now the default
 * (ENG-33713).
 *
 * Serialized once at module scope rather than per render.
 */
const STYLES: Record<ThemeMode, ReturnType<typeof buildStyles>> = {
  light: buildStyles(colors.bg.app.light),
  dark: buildStyles(colors.bg.app.dark),
}

export const GlobalStyles = () => {
  const mode = useLightMode()
  return <Global styles={STYLES[mode]} />
}
